export const LOGIN_API_PATH = '/api/v1/login';
export const CURRENT_USER_API_PATH = '/api/v1/current-user';
export const STRATA_SEARCH_ORDERS = '/api/v1/strata/search';
export const STRATA_MARK_PROCESSED = '/api/v1/strata/mark-processed';
export const RETRY_TRANSFER_API = '/api/v1/cancel/transfer/brs';
export const CHECK_PRE_FLIGHT_STATUS = '/workflow/get_latest_preflight_status';
export const CANCEL_TRANSCODES_API = '/workflow/cancel-transcodes';
export const RETRY_FAILED_TRANSCODES_API = '/workflow/retry-failed-transcodes';
export const RETRY_NOTIFICATIONS_API = '/workflow/retry-notifications';
